const CURRENCY_SMALL_UNIT_NAMES = {
  USD: 'cents',
  EUR: 'cents',
  GBP: 'pennies',
};

export const mapCurrencyIntoHtmlCodeAndSymbol = (currencyString, currencies = null) => {
  let currencySymbol;
  let smallCurrencyUnitName;

  if (!currencyString) {
    return { currencySymbol: '', smallCurrencyUnitName: '' };
  }

  if (!currencies || !Array.isArray(currencies) || currencies.length === 0) {
    currencySymbol = '';
    smallCurrencyUnitName = CURRENCY_SMALL_UNIT_NAMES[currencyString] || '';
    return { currencySymbol, smallCurrencyUnitName };
  }

  const currency = currencies.find((c) => c.currency === currencyString);

  if (!currency || !currency.symbol) {
    currencySymbol = '';
    smallCurrencyUnitName = CURRENCY_SMALL_UNIT_NAMES[currencyString] || '';
    return { currencySymbol, smallCurrencyUnitName };
  }

  currencySymbol = currency.symbol;
  smallCurrencyUnitName = CURRENCY_SMALL_UNIT_NAMES[currencyString] || '';
  return { currencySymbol, smallCurrencyUnitName };
};
